import NeedsCalculatorFormModel from '@/models/needscalculator/needs-calculator-form-model'

export default class RecommendationsModel {
  needsCalculatorForm = new NeedsCalculatorFormModel()

  recommendedOfferingIds: number[] = []
}
